import { CLEAR_BET_BY_MATCH, CLEAR_BET_BY_USERNAME } from "./actionTypes";

export const clearBetByUsername = ()=>({
    type:CLEAR_BET_BY_USERNAME
})

export const clearBetByMatch = ()=>({
    type:CLEAR_BET_BY_MATCH
})